<template>
  <b-modal id="dailyPlanHoldModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.dailyplan.holdHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="dailyPlanItem">
      <b-col>
        <p>{{ $t('modals.dailyplan.task.startDate') }}: <b>{{ $moment(dailyPlanItem.task.startDate).format('YYYY-MM-DD HH:mm:ss') }}</b></p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.dailyplan.finishDate')}}:</label>
          <fg-input>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="date"
              :placeholder="$t('modals.dailyplan.finishDate')"
              type="datetime">
            </el-date-picker>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="btn btn-success" @click="hold()">{{ $t('buttons.submit') }}</b-button>
        <b-button class="btn btn-danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import getId from '@/utils/getIdFromLink'
export default {
  name: 'DailyPlanHoldModal',
  computed: {
    show () {
      return this.$store.state.modals.dailyplan.hold.show
    },
    dailyPlanItemObject () {
      return this.$store.state.modals.dailyplan.hold.dailyPlanItemObject
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'dailyPlanItemObject': function (val) {
      this.openModal()
    }
  },
  data () {
    return {
      dailyPlanItem: null,
      date: '',
      idUserData: null,
      servicemenOptions: [],
      holdReason: ''
    }
  },
  methods: {
    hold () {
      let date = this.$moment(this.date).format('YYYY-MM-DD HH:mm:ss')
      let taskStartDate = this.$moment(this.dailyPlanItem.task.startDate).format('YYYY-MM-DD HH:mm:ss')

      if (!(taskStartDate < date)) {
        let text = this.$t('error.timeStartLaterThanTimeStop')
        this.$Swal({
          type: 'warning',
          title: text,
          timer: 2500
        })
      } else {
        let id = this.getIdLink(this.dailyPlanItem['@id'])
        let params = {
          date: this.$moment(this.date).format('YYYY-MM-DD HH:mm:ss'),
          holdReason: this.holdReason
        }
        this.$http
          .put('api/e_x_c_m_daily_plan_items/' + id + '/hold',
            params
          )
          .then(response => {
            this.$Swal({
              type: 'success',
              title: this.$t('notifications.operationDone'),
              timer: 2500
            })
            this.$store.state.modals.dailyplan.hold.holded = 1
            this.closeModal()
          })
          .catch(error => {
            if (error.response.status === 400) {
              let text = ''
              for (let i in error.response.data) {
                text += error.response.data[i] + '\n'
              }
              this.$Swal({
                type: 'warning',
                title: text,
                timer: 2500
              })
            }
            console.log(error)
          })
      }
    },

    getServicemen () {
      let params = {
        'pagination': false,
        'isCompany': 0,
        'state': 1,
        'idClientType': 5
      }
      this.servicemenOptions = []
      this.$http.get('api/user_datas', {
        params
      })
        .then(response => {
          this.servicemenOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    openModal () {
      if (this.show === 1 && this.dailyPlanItemObject) {
        this.dailyPlanItem = Object.assign({}, this.dailyPlanItemObject)
        // this.idUserData = this.dailyPlanItem
        this.$store.state.modals.dailyplan.hold.show = 0
        this.$store.state.modals.dailyplan.hold.dailyPlanItemObject = null
        this.$bvModal.show('dailyPlanHoldModal')
        this.getServicemen()
      }
    },
    closeModal () {
      this.$bvModal.hide('dailyPlanHoldModal')
    },
    resetData () {
      this.date = ''
      this.serviceman = null
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
